import WhatsappButton from '@portalterreno/react-ui-core/WhatsappButton';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { RootState } from '../../../redux/store';
import StyledDiv from './StyledDiv';

export type ButtonProps = {
  onClickWhatsappButton: () => void;
};

const DesktopButton: React.FC<ButtonProps> = ({ onClickWhatsappButton }) => {
  const state = useSelector(
    (state: RootState) => ({
      isContactButtonLoading: state.contactForm.isContactButtonLoading,
      isWhatsappButtonLoading: state.contactForm.isWhatsappButtonLoading,
      isWhatsappFormSent: state.contactForm.isWhatsappFormSent
    }),
    shallowEqual
  );

  const { t } = useTranslation('property');

  return (
    <StyledDiv>
      <WhatsappButton
        type='button'
        fullWidth
        onClick={onClickWhatsappButton}
        loading={state.isWhatsappButtonLoading}
        disabled={state.isWhatsappFormSent || state.isContactButtonLoading}
      >
        {t('contactByWhatsapp')}
      </WhatsappButton>
    </StyledDiv>
  );
};

export default DesktopButton;
